import { ReactNode } from 'react';

// Each route renders its own <s-page>; the frame only reserves space below content.
const AppFrame = ({ children }: { children?: ReactNode }) => (
    <div className="pf-app-admin-content">
        {children}
    </div>
);

export default AppFrame;
